import type { Connector } from '@particle-network/connector-core';
import { useCallback, useState } from 'react';
import useConnect from './useConnect';
import { useConnector } from './useConnectors';
import { useLastConnectorId } from './useLastConnectorId';

export function useWalletConnectUri(connectorId?: string) {
  const connector = useConnector('walletConnect');
  const { connectAsync } = useConnect();
  const { updateLastConnectorId } = useLastConnectorId();

  const [uri, setUri] = useState<string>();
  const [error, setError] = useState<Error>();

  const handleMessage = useCallback((message) => {
    const { type, data } = message;
    console.log('walletConnect Message', type, data);
    if (type === 'display_uri') {
      setUri(data);
    }
  }, []);

  const connectWalletConnect = useCallback(
    async (connector: Connector) => {
      setError(undefined);
      try {
        await connectAsync({ connector });
        if (connectorId) {
          updateLastConnectorId(connectorId);
        }
      } catch (error: any) {
        console.log('walletConnect requestUri', error);
        setError(error);
      }
    },
    [connectAsync, connectorId, updateLastConnectorId]
  );

  const requestUri = useCallback(() => {
    if (connector) {
      connectWalletConnect(connector);
      connector.emitter.on('message', handleMessage);
    }
  }, [connector, connectWalletConnect, handleMessage]);

  return {
    available: !!connector,
    uri,
    error,
    requestUri,
  };
}
